import { gql } from "@apollo/client";

export default gql`
  query getOrganizationCareerTracks(
    $organizationId: Int!
    $teamId: Int
    $after: String
    $first: Int
    $withHolders: Boolean = false
  ) {
    careerTracks(
      organizationId: $organizationId
      teamId: $teamId
      after: $after
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          team {
            id
            title
          }
          roles {
            edges {
              node {
                id
                title
                level
                roleType
                hasCurrentHolders
                hasHistory
                # Only the pages that list who holds each role ask for them:
                # each role's holders take their own queries.
                assignedUsers @include(if: $withHolders) {
                  edges {
                    node {
                      id
                      name
                      email
                      avatar
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
